
import { supabase } from "@/integrations/supabase/client";
import { FoundationalTask } from "./types";

export const fetchFoundationalTasks = async (
  userId: string, 
  brandId: string
): Promise<FoundationalTask[]> => {
  // Get ALL squad members for the current user in this brand and check user type
  const { data: squadData, error: squadError } = await supabase
    .from('growth_squad')
    .select('id, type')
    .eq('user_id', userId)
    .eq('brand_id', brandId);

  if (squadError) {
    console.error('Error fetching squad data:', squadError);
    throw squadError;
  }

  // If no squad members, return empty array
  if (!squadData || squadData.length === 0) {
    return [];
  }

  // Extract all squad IDs and check if user is Growth Partner
  const squadIds = squadData.map(squad => squad.id);
  const isGrowthPartner = squadData.some(squad => squad.type === 'Growth Partner');

  let query = supabase
    .from('foundational_tasks')
    .select(`
      *,
      growth_sprints!foundational_tasks_sprint_id_fkey (
        id,
        name
      ),
      brands (
        name,
        slug
      ),
      os_tasks_projects!foundational_tasks_project_id_fkey (
        id,
        name,
        description,
        icon
      )
    `)
    .eq('brand_id', brandId)
    .in('assigned_to', squadIds);

  // Filter internal tasks if user is not a Growth Partner
  if (!isGrowthPartner) {
    query = query.eq('internal', false);
  }

  const { data, error } = await query.order('created_at', { ascending: false });

  if (error) throw error;
  
  const tasksWithSprint = (data || []).map(task => {
    return {
      ...task,
      sprint: task.growth_sprints ? {
        id: task.growth_sprints.id,
        name: task.growth_sprints.name
      } : undefined,
      brands: task.brands ? {
        name: task.brands.name,
        slug: task.brands.slug
      } : undefined
    };
  });
  
  return tasksWithSprint;
};

export const deleteFoundationalTask = async (taskId: string): Promise<void> => {
  const { error } = await supabase
    .from('foundational_tasks')
    .delete()
    .eq('id', taskId);

  if (error) throw error;
};
